import { render } from "./shinsei_Settaiedit.vue?vue&type=template&id=0f6a3208&scoped=true&ts=true"
import script from "./shinsei_Settaiedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Settaiedit.vue?vue&type=script&lang=ts"

import "./shinsei_Settaiedit.vue?vue&type=style&index=0&id=0f6a3208&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6a3208"]])

export default __exports__